import axios2 from '../api/axios';
export const shipmentServices = {
    createshipment,
    updateshipment,
    getshipment,
    getfreightlist,
    // deletemanufacturer,
    // getproductname,    
    // getallfreight,
}

function createshipment(objdata){
    return axios2.post(`/createshipment`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function updateshipment(objdata){
    return axios2.post(`/updateshipment`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

//  function deletemanufacturer(id){
//      return axios2.post(`/deletemanufacturer`,id,((response)=>{
//           return response;   
//      })).catch((error)=>{
//           console.log(error); 
//      })  
//  }
 
function getshipment(page,pageSize,{ id = 'all',type = 'all' } = {}){
    return axios2.get(`/getshipment?page=${page}&limit=${pageSize}&id=${id}&type=${type}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}


function getfreightlist(){
    return axios2.get(`/getfreightlist`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getproductname(id=0){
    return axios2.get(`/getproductname/${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getallfreight(){
     return axios2.get(`/getallfreight`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}